import React from 'react'

export type ContextMatchBand = 'HIGH' | 'MEDIUM' | 'LOW'

const CONTEXT_MATCH_BANDS: ContextMatchBand[] = ['HIGH', 'MEDIUM', 'LOW']

export const normalizeContextMatchBand = (value?: unknown): ContextMatchBand | null => {
  if (typeof value !== 'string') return null
  const normalized = value.trim().toUpperCase()
  return CONTEXT_MATCH_BANDS.includes(normalized as ContextMatchBand) ? (normalized as ContextMatchBand) : null
}

type ContextMatchBadgeProps = {
  band?: unknown
}

const ContextMatchBadge = ({ band }: ContextMatchBadgeProps) => {
  const normalized = normalizeContextMatchBand(band)
  if (!normalized) return null

  return (
    <span className={`context-match-badge ${normalized.toLowerCase()}`}>
      Context Match: {normalized}
    </span>
  )
}

export default ContextMatchBadge
